const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
const { usePageType } = require('@fegobull/webapi').use;


/**
 * 判断是否为编辑器
 */
function isEditor() {
    return !!window.FEGOEditor;
}

/**
 * 判断H5还是Web模式
 * @returns
 */
function isPc() {
    const { isPC } = usePageType();
    return isPC;
}

/**
 * 是否预渲染环境下
 * @returns {boolean}
 */
function isPreRender() {
    if (isEditor()) {
        return false;
    }
    const {
        common: {
            env: { isPreRender: isPreRenderFlag }
        }
    } = require('@futuweb/fego-render');
    return isPreRenderFlag;
}



export { isEditor, isPc, isPreRender };
